import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { AvisoError, Seccion, useAccion } from "./comun.tsx";

interface Estado { configurada: boolean; modelo: string }

/**
 * Configuración → «IA de imágenes»: cada clínica pone SU PROPIA clave de Google (Gemini) para generar las simulaciones de sonrisa y de blanqueamiento.
 * Google le cobra a la clínica (centavos por imagen). La clave se guarda cifrada y nunca se vuelve a mostrar.
 */
export function ConfigGemini() {
  const [e, setE] = useState<Estado | null>(null);
  const [clave, setClave] = useState("");
  const [msg, setMsg] = useState("");
  const a = useAccion();
  const cargar = () => api<Estado>("GET", "/api/gemini/estado").then(setE).catch(a.setError);
  useEffect(() => { cargar(); }, []);

  async function guardar() {
    const r = await a.correr(() => api("PUT", "/api/config/gemini", { clave: clave.trim() }));
    if (r) { setClave(""); setMsg("Clave guardada. Pulsa «Probar la clave» para comprobar que Google la acepta."); cargar(); }
  }
  async function probar() {
    setMsg("");
    const r = await a.correr(() => api<{ mensaje: string }>("POST", "/api/config/gemini/probar"));
    if (r) setMsg(r.mensaje);
  }
  async function quitar() {
    if (!confirm("¿Quitar la clave de Gemini? Dejarán de funcionar las simulaciones con IA hasta que pongas otra.")) return;
    const r = await a.correr(() => api("DELETE", "/api/config/gemini"));
    if (r) { setMsg("Clave quitada."); cargar(); }
  }

  return (
    <Seccion titulo="IA de imágenes (simulación de sonrisa y blanqueamiento)">
      <p style={{ margin: 0 }}>
        Con esta clave, Donna genera una imagen de <b>cómo podría quedar la sonrisa</b> de un paciente, solo como referencia. Usa la IA de imágenes de Google (Gemini) con <b>la cuenta de tu clínica</b>:
        Google te cobra directamente, unos 3 o 4 centavos de dólar por imagen. Donna no cobra nada extra.
      </p>
      <div className={`aviso ${e?.configurada ? "ok" : "info"}`} role="status">
        {e === null ? "Revisando…" : e.configurada ? "La clínica tiene una clave guardada." : "La clínica todavía no tiene clave: sin ella no se pueden generar simulaciones."}
      </div>
      <ol style={{ margin: "4px 0 4px 18px", padding: 0, display: "grid", gap: 4 }}>
        <li>Entra a <b>aistudio.google.com/apikey</b> con la cuenta de Google de la clínica y crea una clave.</li>
        <li><b>Activa la facturación</b> del proyecto de esa clave en Google Cloud. Es importante: con facturación, Google dice que no usa las imágenes para mejorar sus productos; sin ella, sí puede usarlas, y no deben enviarse fotos de pacientes.</li>
        <li>Pega la clave aquí abajo y pulsa «Guardar». No la compartas con nadie ni la mandes por chat o correo.</li>
      </ol>
      <label className="campo">Clave de Gemini (de Google AI Studio)
        <input type="password" autoComplete="off" spellCheck={false} value={clave} maxLength={200} placeholder={e?.configurada ? "•••••••• (ya hay una guardada; pega otra para reemplazarla)" : "Pega aquí la clave"} onChange={(x) => setClave(x.target.value)} />
      </label>
      <AvisoError error={a.error} />
      {msg && <div className="aviso ok" role="status">{msg}</div>}
      <div className="fila" style={{ flexWrap: "wrap" }}>
        <button className="btn pri" onClick={guardar} disabled={a.ocupado || clave.trim().length < 20}>Guardar clave</button>
        <button className="btn" onClick={probar} disabled={a.ocupado || !e?.configurada}>Probar la clave</button>
        {e?.configurada && <button className="btn peligro" onClick={quitar} disabled={a.ocupado}>Quitar la clave</button>}
      </div>
      <small className="muted">
        Qué se envía a Google: solo un recorte de la parte baja de la cara (de la nariz al mentón), sin nombre ni datos del paciente, y solo si el paciente autorizó el uso de sus imágenes con IA (Ficha → Datos personales).
        La imagen que se genera es una idea aproximada: no es una promesa de resultado y siempre queda rotulada como simulación. Modelo: {e?.modelo ?? "—"}.
      </small>
    </Seccion>
  );
}
